import { render } from "./PtResourceDialog.vue?vue&type=template&id=2c1de516&scoped=true"
import script from "./PtResourceDialog.vue?vue&type=script&lang=js"
export * from "./PtResourceDialog.vue?vue&type=script&lang=js"

import "./PtResourceDialog.vue?vue&type=style&index=0&id=2c1de516&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1de516"]])

export default __exports__